let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("15G7H")).then(() => parcelRequire('81pCG'));